module.exports = __webpack_public_path__ + "static/img/histoire-06.7134a87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/histoire-06.png
// module id = 91
// module chunks = 0